import React from 'react';

export function FDPIllustration() {
  return (
    <svg
      width="390"
      height="241"
      viewBox="0 0 390 241"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3340_622)">
        <g clip-path="url(#clip0_3340_622)">
          <rect
            x="20.11"
            y="16.5"
            width="349.78"
            height="200"
            rx="6.92641"
            fill="#DFE6FD"
          />
          <rect
            x="27.11"
            y="24.5"
            width="66.9565"
            height="184"
            rx="4"
            fill="white"
          />
          <rect
            x="30.1534"
            y="27.5435"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#FFD2B8"
          />
          <rect
            x="42.3273"
            y="29.8261"
            width="47.1739"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="36.2404"
            y="42"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#D1E3D0"
          />
          <rect
            x="48.4143"
            y="44.2827"
            width="41.087"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="36.2404"
            y="56.4565"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#D1E3D0"
          />
          <rect
            x="48.4143"
            y="58.7391"
            width="41.087"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="42.3273"
            y="70.9131"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#E9D3E5"
          />
          <rect
            x="54.5013"
            y="73.1957"
            width="35"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="48.4143"
            y="85.3696"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#CAD4F9"
          />
          <rect
            x="60.5882"
            y="87.6522"
            width="28.913"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="48.4143"
            y="99.8261"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#CAD4F9"
          />
          <rect
            x="60.5882"
            y="102.109"
            width="28.913"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="36.2404"
            y="114.283"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#D1E3D0"
          />
          <rect
            x="48.4143"
            y="116.565"
            width="41.087"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="42.3273"
            y="128.739"
            width="9.13043"
            height="9.13043"
            rx="3.04348"
            fill="#E9D3E5"
          />
          <rect
            x="54.5013"
            y="131.022"
            width="35"
            height="4.56522"
            rx="2.28261"
            fill="#E8EAF0"
          />
          <rect
            x="124.993"
            y="28.5"
            width="48"
            height="6"
            rx="2.66667"
            fill="#C2C8EE"
          />
          <rect
            x="124.993"
            y="42.5"
            width="213.897"
            height="95.2802"
            rx="6.28221"
            fill="white"
          />
          <rect
            x="131.537"
            y="49.044"
            width="201.029"
            height="9.94684"
            rx="1.83231"
            stroke="#DDE1F9"
            stroke-width="0.523518"
          />
          <rect
            x="136.11"
            y="52.7822"
            width="37"
            height="2"
            rx="1"
            fill="#CCD1DE"
          />
          <rect
            x="131.581"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            stroke="#DDE1F9"
            stroke-width="0.610771"
          />
          <rect
            x="155.488"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            fill="#DFE6FD"
          />
          <rect
            x="155.488"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            stroke="#DFE6FD"
            stroke-width="0.610771"
          />
          <rect
            x="179.395"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            stroke="#DDE1F9"
            stroke-width="0.610771"
          />
          <rect
            x="203.302"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            stroke="#DDE1F9"
            stroke-width="0.610771"
          />
          <rect
            x="227.21"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            stroke="#DDE1F9"
            stroke-width="0.610771"
          />
          <rect
            x="251.117"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            fill="#DFE6FD"
          />
          <rect
            x="251.117"
            y="65.8402"
            width="20.1554"
            height="6.71848"
            rx="2.1377"
            stroke="#DFE6FD"
            stroke-width="0.610771"
          />
          <rect
            x="131.537"
            y="79.408"
            width="200.809"
            height="9.94684"
            rx="1.83231"
            stroke="#DDE1F9"
            stroke-width="0.523518"
          />
          <path
            d="M138.837 115.169H137.444C136.418 115.169 135.586 114.337 135.586 113.311V89.388"
            stroke="#BCC4F3"
            stroke-width="0.232264"
          />
          <path
            d="M138.837 95.1946H137.444C136.418 95.1946 135.586 94.3627 135.586 93.3365V91.7107"
            stroke="#BCC4F3"
            stroke-width="0.232264"
          />
          <path
            d="M138.837 105.182H137.444C136.418 105.182 135.586 104.35 135.586 103.324V101.698"
            stroke="#BCC4F3"
            stroke-width="0.232264"
          />
          <rect
            x="141.16"
            y="92.9073"
            width="28.7187"
            height="4.78645"
            rx="2.39322"
            fill="#DFE6FD"
          />
          <rect
            x="141.16"
            y="102.48"
            width="37.095"
            height="4.78645"
            rx="2.39322"
            fill="#DFE6FD"
          />
          <rect
            x="141.16"
            y="112.053"
            width="23.9322"
            height="4.78645"
            rx="2.39322"
            fill="#DFE6FD"
          />
          <rect
            x="131.537"
            y="121.289"
            width="200.809"
            height="9.94684"
            rx="1.83231"
            stroke="#DDE1F9"
            stroke-width="0.523518"
          />
          <rect
            x="124.993"
            y="153.78"
            width="213.897"
            height="70.6258"
            rx="6.22298"
            fill="white"
          />
          <rect
            x="131.478"
            y="160.265"
            width="201.029"
            height="9.94684"
            rx="1.83231"
            stroke="#DDE1F9"
            stroke-width="0.523518"
          />
          <rect
            x="136.051"
            y="164.003"
            width="37"
            height="2"
            rx="1"
            fill="#CCD1DE"
          />
          <rect
            x="130.957"
            y="176.437"
            width="201.97"
            height="42.0051"
            rx="2.33362"
            stroke="#DCE0E9"
            stroke-width="0.518582"
          />
          <path
            d="M131.216 178.771C131.216 177.625 132.145 176.697 133.29 176.697H330.593C331.738 176.697 332.667 177.625 332.667 178.771V187.068H131.216V178.771Z"
            fill="#F5F6F8"
          />
          <rect
            x="136.478"
            y="192.254"
            width="108.902"
            height="2.07433"
            rx="1.03716"
            fill="#E8EAF0"
          />
          <rect
            x="136.478"
            y="198.477"
            width="80.8987"
            height="2.07433"
            rx="1.03716"
            fill="#E8EAF0"
          />
          <rect
            x="136.11"
            y="210.5"
            width="157"
            height="2"
            rx="1"
            fill="#E8EAF0"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3340_622"
          x="0.109985"
          y="0.5"
          width="389.78"
          height="240"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3340_622"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3340_622"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3340_622">
          <rect
            x="20.11"
            y="16.5"
            width="349.78"
            height="200"
            rx="6.92641"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NewSequenceIllustraction() {
  return (
    <svg
      width="241"
      height="176"
      viewBox="0 0 241 176"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3314_406)">
        <rect
          x="79.272"
          y="15"
          width="142.426"
          height="130"
          rx="7.64706"
          fill="white"
        />
        <rect
          x="86.9189"
          y="25.5147"
          width="33.4559"
          height="5.73529"
          rx="2.86765"
          fill="#576183"
        />
        <rect
          x="86.9189"
          y="33.1618"
          width="20.0735"
          height="2.86765"
          rx="1.43382"
          fill="#959CB1"
        />
        <rect
          x="86.9189"
          y="43.6765"
          width="43.0147"
          height="3.82353"
          rx="1.91176"
          fill="#FFD2B8"
        />
        <rect
          x="87.1579"
          y="55.386"
          width="126.654"
          height="25.3309"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="91.6985"
          y="61.8382"
          width="70.7353"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="91.6985"
          y="67.5735"
          width="60.2206"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="91.6985"
          y="73.3088"
          width="96.5441"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="87.1579"
          y="85.0184"
          width="126.654"
          height="19.5956"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="91.6985"
          y="91.4706"
          width="16.25"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="109.86"
          y="91.4706"
          width="16.25"
          height="1.91176"
          rx="0.955882"
          fill="#C1E8D7"
        />
        <rect
          x="91.6985"
          y="97.2059"
          width="60.2206"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="87.1579"
          y="108.915"
          width="126.654"
          height="25.3309"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="91.6985"
          y="115.368"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#FFD9E0"
        />
        <rect
          x="106.993"
          y="115.368"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#CAD4F9"
        />
        <rect
          x="122.287"
          y="115.368"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#FDE3BD"
        />
        <rect
          x="91.6985"
          y="121.103"
          width="104.191"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="91.6985"
          y="126.838"
          width="55.4412"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
      </g>
      <g filter="url(#filter1_d_3314_406)">
        <rect
          x="51.272"
          y="20"
          width="142.426"
          height="130"
          rx="7.64706"
          fill="white"
        />
        <rect
          x="58.9189"
          y="30.5147"
          width="33.4559"
          height="5.73529"
          rx="2.86765"
          fill="#576183"
        />
        <rect
          x="58.9189"
          y="38.1618"
          width="20.0735"
          height="2.86765"
          rx="1.43382"
          fill="#959CB1"
        />
        <rect
          x="58.9189"
          y="48.6765"
          width="43.0147"
          height="3.82353"
          rx="1.91176"
          fill="#FFD2B8"
        />
        <rect
          x="59.1579"
          y="60.386"
          width="126.654"
          height="25.3309"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="63.6985"
          y="66.8382"
          width="70.7353"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="63.6985"
          y="72.5735"
          width="60.2206"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="63.6985"
          y="78.3088"
          width="96.5441"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="59.1579"
          y="90.0184"
          width="126.654"
          height="19.5956"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="63.6985"
          y="96.4706"
          width="16.25"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="81.8601"
          y="96.4706"
          width="16.25"
          height="1.91176"
          rx="0.955882"
          fill="#C1E8D7"
        />
        <rect
          x="63.6985"
          y="102.206"
          width="60.2206"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
        <rect
          x="59.1579"
          y="113.915"
          width="126.654"
          height="25.3309"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="63.6985"
          y="120.368"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#FFD9E0"
        />
        <rect
          x="78.9927"
          y="120.368"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#CAD4F9"
        />
        <rect
          x="94.2869"
          y="120.368"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#FDE3BD"
        />
        <rect
          x="63.6985"
          y="126.103"
          width="104.191"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="63.6985"
          y="131.838"
          width="55.4412"
          height="1.91176"
          rx="0.955882"
          fill="#959CB1"
        />
      </g>
      <g filter="url(#filter2_d_3314_406)">
        <rect
          x="19.272"
          y="25"
          width="142.426"
          height="128.265"
          rx="7.64706"
          fill="white"
        />
        <rect
          x="26.9189"
          y="35.5147"
          width="36"
          height="4"
          rx="2"
          fill="#959CB1"
        />
        <rect
          x="26.9189"
          y="41.4265"
          width="20.0735"
          height="2.86765"
          rx="1.43382"
          fill="#C3C7D3"
        />
        <rect
          x="26.9189"
          y="51.9412"
          width="43.0147"
          height="3.82353"
          rx="1.91176"
          fill="#FFD2B8"
        />
        <rect
          x="27.1579"
          y="63.6507"
          width="126.654"
          height="25.3309"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="31.6985"
          y="70.103"
          width="70.7353"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="31.6985"
          y="75.8383"
          width="60.2206"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="31.6985"
          y="81.5736"
          width="96.5441"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="27.1579"
          y="93.2831"
          width="126.654"
          height="19.5956"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="31.6985"
          y="99.7353"
          width="16.25"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="49.8601"
          y="99.7353"
          width="16.25"
          height="1.91176"
          rx="0.955882"
          fill="#C1E8D7"
        />
        <rect
          x="31.6985"
          y="105.471"
          width="60.2206"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="27.1579"
          y="117.18"
          width="126.654"
          height="25.3309"
          rx="5.60485"
          stroke="#C6CBD7"
          stroke-width="0.477941"
        />
        <rect
          x="31.6985"
          y="123.632"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#FFD9E0"
        />
        <rect
          x="46.9927"
          y="123.632"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#CAD4F9"
        />
        <rect
          x="62.2869"
          y="123.632"
          width="13.3824"
          height="1.91176"
          rx="0.955882"
          fill="#FDE3BD"
        />
        <rect
          x="31.6985"
          y="129.368"
          width="104.191"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
        <rect
          x="31.6985"
          y="135.103"
          width="55.4412"
          height="1.91176"
          rx="0.955882"
          fill="#C3C7D3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3314_406"
          x="60.7005"
          y="0.142858"
          width="179.569"
          height="167.143"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.71429" />
          <feGaussianBlur stdDeviation="9.28571" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3314_406"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3314_406"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3314_406"
          x="32.7005"
          y="5.14286"
          width="179.569"
          height="167.143"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.71429" />
          <feGaussianBlur stdDeviation="9.28571" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3314_406"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3314_406"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3314_406"
          x="0.700544"
          y="10.1429"
          width="179.569"
          height="165.408"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.71429" />
          <feGaussianBlur stdDeviation="9.28571" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3314_406"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3314_406"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function NewFDPAloneIllustration() {
  return (
    <svg
      width="216"
      height="178"
      viewBox="0 0 216 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3314_377)">
        <rect
          x="31.25"
          y="16.0882"
          width="153.382"
          height="137.824"
          rx="8.23529"
          fill="white"
        />
        <rect
          x="39.4854"
          y="27.4117"
          width="36"
          height="4"
          rx="2"
          fill="#959CB1"
        />
        <rect
          x="39.4854"
          y="33.4706"
          width="21.6176"
          height="3.08824"
          rx="1.54412"
          fill="#C3C7D3"
        />
        <rect
          x="39.4854"
          y="44.7941"
          width="46.3235"
          height="4.11765"
          rx="2.05882"
          fill="#FFD2B8"
        />
        <rect
          x="39.7427"
          y="57.4044"
          width="136.397"
          height="27.2794"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="44.6326"
          y="64.3529"
          width="76.1765"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="44.6326"
          y="70.5294"
          width="64.8529"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="44.6326"
          y="76.7059"
          width="103.971"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="39.7427"
          y="89.3162"
          width="136.397"
          height="21.1029"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="44.6326"
          y="96.2647"
          width="17.5"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="64.1914"
          y="96.2647"
          width="17.5"
          height="2.05882"
          rx="1.02941"
          fill="#C1E8D7"
        />
        <rect
          x="44.6326"
          y="102.441"
          width="64.8529"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="39.7427"
          y="115.051"
          width="136.397"
          height="27.2794"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="44.6326"
          y="122"
          width="14.4118"
          height="2.05882"
          rx="1.02941"
          fill="#FFD9E0"
        />
        <rect
          x="61.1033"
          y="122"
          width="14.4118"
          height="2.05882"
          rx="1.02941"
          fill="#CAD4F9"
        />
        <rect
          x="77.5737"
          y="122"
          width="14.4118"
          height="2.05882"
          rx="1.02941"
          fill="#FDE3BD"
        />
        <rect
          x="44.6326"
          y="128.176"
          width="112.206"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="44.6326"
          y="134.353"
          width="59.7059"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3314_377"
          x="11.25"
          y="0.0882263"
          width="193.382"
          height="177.824"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3314_377"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3314_377"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function NewFDPFromScratchIllustration() {
  return (
    <svg
      width="216"
      height="179"
      viewBox="0 0 216 179"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4122_5797)">
        <rect
          x="31.25"
          y="16.5879"
          width="153.382"
          height="137.824"
          rx="8.23529"
          fill="white"
        />
        <rect
          x="39.4853"
          y="27.9111"
          width="36"
          height="4"
          rx="2"
          fill="#959CB1"
        />
        <rect
          x="39.4853"
          y="33.9697"
          width="21.6176"
          height="3.08824"
          rx="1.54412"
          fill="#C3C7D3"
        />
        <rect
          x="39.5073"
          y="45.7574"
          width="136.485"
          height="29.4853"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="44.2499"
          y="52.5"
          width="29"
          height="2"
          rx="1"
          fill="#C3C7D3"
        />
        <rect
          x="44.2499"
          y="66.5"
          width="22"
          height="2"
          rx="1"
          fill="#C3C7D3"
        />
        <line
          x1="44.4999"
          y1="60.25"
          x2="173"
          y2="60.25"
          stroke="#C6CBD7"
          stroke-width="0.5"
          strokeLinecap="round"
        />
        <rect
          x="39.4853"
          y="83.5293"
          width="33"
          height="8"
          rx="4"
          fill="#B8C2FB"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4122_5797"
          x="11.25"
          y="0.587891"
          width="193.382"
          height="177.823"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4122_5797"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4122_5797"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function NewFDPFromTemplateIllustration() {
  return (
    <svg
      width="216"
      height="180"
      viewBox="0 0 216 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4122_5813)">
        <rect
          x="31.75"
          y="16.8828"
          width="153.382"
          height="138.235"
          rx="8.23529"
          fill="white"
        />
        <rect
          x="39.9853"
          y="28.2061"
          width="36"
          height="4"
          rx="2"
          fill="#959CB1"
        />
        <rect
          x="39.9853"
          y="34.2646"
          width="21.6176"
          height="3.08824"
          rx="1.54412"
          fill="#C3C7D3"
        />
        <rect
          x="39.9853"
          y="45.5889"
          width="46.3235"
          height="4.11765"
          rx="2.05882"
          fill="#FFD2B8"
        />
        <rect
          x="40.0073"
          y="58.0513"
          width="136.485"
          height="24.4853"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="45.1324"
          y="65.1475"
          width="76.1765"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="44.7499"
          y="71.7939"
          width="114"
          height="4"
          rx="2"
          fill="#B8C2FB"
        />
        <rect
          x="40.2426"
          y="87.3159"
          width="136.397"
          height="21.1029"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="45.1324"
          y="94.2646"
          width="17.5"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
        <rect
          x="44.7499"
          y="100"
          width="128"
          height="4"
          rx="2"
          fill="#C1E8D7"
        />
        <rect
          x="40.0073"
          y="113.257"
          width="136.485"
          height="30.4853"
          rx="6.03599"
          stroke="#C6CBD7"
          stroke-width="0.514706"
        />
        <rect
          x="44.7499"
          y="126"
          width="113"
          height="4"
          rx="2"
          fill="#FDE3BD"
        />
        <rect x="44.7499" y="134" width="60" height="4" rx="2" fill="#FFD9E0" />
        <rect
          x="44.7499"
          y="119"
          width="17.5"
          height="2.05882"
          rx="1.02941"
          fill="#C3C7D3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4122_5813"
          x="11.75"
          y="0.882812"
          width="193.382"
          height="178.235"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4122_5813"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4122_5813"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
